import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

import styled from 'styled-components'

import ReactSelect, { components } from 'react-select'

import FormGroup from '../FormGroup'

const ClearButton = styled.button`
    white-space: nowrap;
`

const Option = props => {
    const dataProp = {
        innerProps: {
            'data-testid': props.data.value
                .toString()
                .toLowerCase()
                .replaceAll(' ', '-'),
            ...props.innerProps,
        },
    }
    return <components.Option {...{ ...props, ...dataProp }} />
}

const SelectWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .list__menu {
        z-index: 100;
    }
`

const Select = ({
    name,
    label = '',
    help,
    tooltip,
    placeholder = false,
    options = [],
    setFieldValue,
    handleChange = () => {},
    className = '',
    showWhen,
    defaultValue = { label: 'Please Select', value: null },
    allowClear = false,
    required,
    testId,
    testIdItems,
    testIdIndex,
    component,
    disabled,
    ...props
}) => {
    useEffect(() => {
        if (testId !== undefined) {
            const temp = document.getElementsByClassName('list__single-value')

            if (temp.length > 0) {
                for (let index = 0; index < temp.length; index++) {
                    const t1 = temp[index]

                    if (testIdIndex >= 0) {
                        if (index === testIdIndex) {
                            let t2 = document.createAttribute('data-testid')
                            t2.value = testIdItems
                            t1.setAttributeNode(t2)
                        }
                    }

                    if (!testIdIndex) {
                        let t2 = document.createAttribute('data-testid')
                        t2.value = testIdItems
                        t1.setAttributeNode(t2)
                    }
                }
            } else {
                const t1 = temp[0]
                let t2 = document.createAttribute('data-testid')
                t2.value = testIdItems
                t1.setAttributeNode(t2)
            }
        }
    }, [testId, testIdIndex, testIdItems])

    return (
        <Field name={name}>
            {({ field, form }) => {
                let formError = getIn(form.errors, name)
                let error = null

                if (formError?.replace) {
                    const errorFieldName = label ? label : 'This'
                    error = formError.replace(field.name, errorFieldName)
                }

                if (showWhen) {
                    const showField = form.values.hasOwnProperty(showWhen)
                        ? form.values[showWhen]
                        : false

                    if (!showField) {
                        return null
                    }
                }

                props.className = classNames(className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                if (allowClear) {
                    if (options?.length > 0 && options[0].value != '') {
                        options.unshift({ label: placeholder || 'Please Select...', value: '' })
                    }
                }

                const customStyles = {
                    menu: base => ({
                        ...base,
                        marginBottom: '70px',
                    }),
                }

                return (
                    <FormGroup
                        {...{ name, label, help, error, tooltip, required }}
                        className={props.className}
                    >
                        <SelectWrapper data-testid={testId}>
                            <ReactSelect
                                components={{ Option }}
                                className="!w-full"
                                classNamePrefix="list"
                                isDisabled={form.isSubmitting || disabled}
                                name={field.name}
                                value={
                                    options && field.value !== null
                                        ? options.find(option => option.value === field.value)
                                        : defaultValue
                                }
                                defaultValue={defaultValue}
                                onChange={option => {
                                    form.setFieldValue(field.name, option.value)
                                    handleChange(option.value)
                                }}
                                onBlur={field.onBlur}
                                options={options}
                                placeholder={placeholder || 'Please Select...'}
                                styles={customStyles}
                            />

                            {allowClear && (
                                <ClearButton
                                    className="btn btn-link"
                                    onClick={e => {
                                        e.preventDefault()
                                        form.setFieldValue(field.name, null)
                                        handleChange(null)
                                    }}
                                    disabled={form.isSubmitting || disabled}
                                    data-testid={`clear-${field.name
                                        .toLowerCase()
                                        .replaceAll(' ', '-')}`}
                                >
                                    <FontAwesomeIcon icon={faTimes} className="!mr-2" />
                                    Clear Value
                                </ClearButton>
                            )}
                        </SelectWrapper>
                    </FormGroup>
                )
            }}
        </Field>
    )
}

Select.displayName = 'Select'

Select.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
}

export default Select
